import type { ListSubheaderOwnProps as MuiListSubheaderProps } from '@mui/material/ListSubheader';

import MuiListSubheader from '@mui/material/ListSubheader';
import classNames from 'classnames';
import React from 'react';

import './ListSubheader.scss';

export interface ListSubheaderProps extends MuiListSubheaderProps {
  className?: string;
}

const ListSubheader = React.forwardRef(
  (props: ListSubheaderProps, ref: React.ForwardedRef<HTMLLIElement>) => {
    return (
      <MuiListSubheader
        {...props}
        className={classNames('Mfw-MuiListSubheader', props.className)}
        ref={ref}
      >
        {props.children}
      </MuiListSubheader>
    );
  },
);

ListSubheader.displayName = 'SubList';

export default ListSubheader;
